import { $, $$ } from '../../../../shared/js/utils/dom';

const fileInputs = $$('.input-file:not(.input-file--no-js)');
const docLang = document.documentElement.lang;
const lang = docLang.length > 2 ? docLang.substring(0, 2) : docLang;
const statusLabel = {
  de: 'Alle Dateien gelöscht',
  en: 'All files deleted',
};

fileInputs.forEach(fileInput => {
  const input = $('.input-file__input input', fileInput);
  const status = $('.input-file__status', fileInput);
  const selectFileButton = $('.input-file__button--select', fileInput);
  const deleteAllFilesButton =
    $('.input-file__button--delete', fileInput) || null;
  const uploadStatus = $('.input-file__upload-status', fileInput) || null;
  const origStatusText = status.textContent;

  input.addEventListener('change', function (e) {
    status.textContent =
      this.files &&
      ([...this.files].map(file => file.name).join(', ') || origStatusText);
  });
  input.addEventListener('focusin', function () {
    selectFileButton.classList.add('has-focus');
  });
  input.addEventListener('focusout', function () {
    selectFileButton.classList.remove('has-focus');
  });

  deleteAllFilesButton &&
    deleteAllFilesButton.addEventListener('click', function () {
      uploadStatus.textContent = statusLabel[lang];
    });
});
